import { render, staticRenderFns } from "./TextQuiz.vue?vue&type=template&id=37b408e8&scoped=true&"
import script from "./TextQuiz.vue?vue&type=script&lang=js&"
export * from "./TextQuiz.vue?vue&type=script&lang=js&"
import style0 from "./TextQuiz.vue?vue&type=style&index=0&id=37b408e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b408e8",
  null
  
)

export default component.exports